import {AbstractControl,UntypedFormControl, ValidationErrors} from "@angular/forms";
export function isValidValue(input) {
    if (input == "" || input == null || input == 'undefined' || typeof input == undefined)
        return false;

    return true;
}

/**
 * Validator function that checks if the control's value contains only whitespace.
 * @param {UntypedFormControl} control - The form control to validate.
 */
export function noWhitespaceValidator(control: UntypedFormControl) {
    const isWhitespace = (control && control.value && control.value.toString() || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : {'whitespace': true};
}

/**
 * Validates that the control's value does not contain any spaces.
 * @param {AbstractControl} control - The control whose value is to be validated.
 */
export function cannotContainSpace(control: AbstractControl): ValidationErrors | null {
    if ((control.value as string).indexOf(' ') >= 0) {
        return {cannotContainSpace: true}
    }

    return null;
}
